import { ReactNode, Suspense, useMemo } from 'react'
import { Brand } from '../../../server/src/user/user.contract'
import Loading from './loading'
import { createLazyLayout } from './pages/brand/layout-registry'

interface BrandLayoutWrapperProps {
  brand: Brand
  children: ReactNode
}

/**
 * Pure layout wrapper component that accepts children
 * This is used for non-router contexts (like mobile preview)
 */
export default function BrandLayoutWrapper({
  brand,
  children,
}: BrandLayoutWrapperProps) {
  const BrandedLayoutWrapper = useMemo(() => createLazyLayout(brand), [brand])

  return (
    <Suspense fallback={<Loading />}>
      <BrandedLayoutWrapper>{children}</BrandedLayoutWrapper>
    </Suspense>
  )
}
